<template>
  <div class="main-page"
    :class="{loaded: isLoad}"
  >
    <div class="main-page-decore"></div>
    <x-header/>
    <div id="content" class="main-content">
      <slot />
    </div>
    <x-footer/>

    <project-sprites style="position: absolute;width: 0;height: 0"/>
    <common-sprites style="position: absolute;width: 0;height: 0"/>
    <div id="gallery"></div>

    <sprites :use-current-color="false" style="position: absolute">
      <symbol id="icon-arrow-left" viewBox="0 0 20 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19.5303 7.03033C19.8232 6.73744 19.8232 6.26256 19.5303 5.96967L14.7574 1.1967C14.4645 0.903806 13.9896 0.903806 13.6967 1.1967C13.4038 1.48959 13.4038 1.96447 13.6967 2.25736L17.9393 6.5L13.6967 10.7426C13.4038 11.0355 13.4038 11.5104 13.6967 11.8033C13.9896 12.0962 14.4645 12.0962 14.7574 11.8033L19.5303 7.03033ZM0 7.25H19V5.75H0V7.25Z" fill="currentcolor" stroke="none"/>
      </symbol>
      <symbol id="icon-arrow-right" viewBox="0 0 20 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19.5303 7.03033C19.8232 6.73744 19.8232 6.26256 19.5303 5.96967L14.7574 1.1967C14.4645 0.903806 13.9896 0.903806 13.6967 1.1967C13.4038 1.48959 13.4038 1.96447 13.6967 2.25736L17.9393 6.5L13.6967 10.7426C13.4038 11.0355 13.4038 11.5104 13.6967 11.8033C13.9896 12.0962 14.4645 12.0962 14.7574 11.8033L19.5303 7.03033ZM0 7.25H19V5.75H0V7.25Z" fill="currentcolor" stroke="none"/>
      </symbol>
      <symbol id="icon-person" viewBox="0 0 512 512">
        <path stroke="none" fill="currentcolor" class="st0" d="M464.496,431.904c-13.636-24.598-34.497-41.724-54.571-53.835c-20.086-12.104-39.685-19.308-51.156-23.611
          c-8.74-3.246-17.968-7.456-24.307-11.92c-3.174-2.204-5.578-4.463-6.91-6.3c-1.363-1.883-1.635-3.04-1.646-3.958
          c0-8.743,0-19.675,0-34.305c1.263-3.193,2.584-5.796,4.076-8.215c2.527-4.15,5.892-8.344,9.268-14.653
          c2.802-5.26,5.302-11.882,7.235-20.548c1.7-0.827,3.395-1.784,5.048-2.94c5.068-3.499,9.356-8.598,12.862-15.266
          c3.545-6.699,6.604-15.098,9.865-26.474l-0.027,0.076l0.027-0.084c1.677-5.902,2.481-11.086,2.484-15.802
          c0.058-7.579-2.312-14.148-6.232-18.582c-1.366-1.569-2.844-2.756-4.329-3.782c0.494-5.834,1.385-13.574,2.231-22.5
          c0.98-10.358,1.864-22.202,1.864-34.467c-0.038-19.408-2.105-39.902-10.316-57.587c-4.115-8.82-9.887-16.934-17.769-23.342
          c-7.262-5.918-16.33-10.16-26.849-12.395c-7.139-5.474-14.052-10.266-22.669-13.597c-9.302-3.605-20.039-5.274-34.222-5.266
          c-4.475,0-9.317,0.16-14.615,0.482C229.032,3.1,216.909,4.9,205.203,4.869c-8.165-0.008-16.223-0.789-25.559-3.446L174.642,0
          l-3.985,3.338c-12.261,10.412-18.842,25.93-22.868,43.171c-3.978,17.318-5.267,36.786-5.279,56.087
          c0.004,25.188,2.255,50.069,4.169,68.742c-1.459,0.949-2.909,2.044-4.284,3.506c-4.226,4.426-6.875,11.27-6.802,19.209
          c0.004,4.708,0.808,9.891,2.484,15.786l0.008,0.031c4.356,15.158,8.295,25.088,13.624,32.621c2.656,3.744,5.742,6.806,9.095,9.126
          c1.646,1.148,3.33,2.098,5.022,2.924c3.035,12.969,8.146,22.37,12.529,29.176c2.465,3.851,4.643,6.913,5.99,9.202
          c1.29,2.144,1.673,3.369,1.75,3.928c0,15.228,0,26.451,0,35.431c0.004,0.713-0.276,1.968-1.792,3.982
          c-2.197,2.978-6.99,6.775-12.735,9.991c-5.735,3.269-12.361,6.102-18.16,8.146c-15.614,5.528-45.239,16.315-71.468,37.315
          c-13.114,10.511-25.425,23.665-34.478,40.094C38.405,448.22,32.72,467.91,32.74,490.794c0,3.973,0.169,8.054,0.517,12.226
          l0.75,8.98h443.986l0.75-8.98c0.348-4.164,0.517-8.23,0.517-12.203C479.279,467.941,473.579,448.28,464.496,431.904z
           M459.592,492.401H52.408c-0.008-0.528-0.069-1.087-0.069-1.607c0.015-19.684,4.754-35.814,12.291-49.534
          c11.289-20.533,29.242-35.692,47.474-46.686c18.217-10.994,36.453-17.692,47.818-21.696c8.954-3.169,19.354-7.756,28.212-13.903
          c4.429-3.093,8.506-6.577,11.782-10.871c3.235-4.241,5.773-9.623,5.776-15.825c0-9.149,0-20.579,0-36.258v-0.505l-0.054-0.506
          c-0.532-4.9-2.48-8.766-4.444-12.096c-3.013-5.023-6.4-9.394-9.497-15.059c-3.085-5.643-5.96-12.456-7.667-22.049l-0.992-5.604
          l-5.359-1.914c-2.45-0.88-4.203-1.73-5.681-2.756c-2.174-1.546-4.187-3.613-6.744-8.368c-2.519-4.723-5.286-11.996-8.322-22.669
          v-0.007c-1.305-4.548-1.742-7.993-1.742-10.435c0.077-4.196,1.01-5.183,1.516-5.819c0.543-0.612,1.512-1.079,2.587-1.317
          l8.521-1.906l-0.915-8.682c-2.01-19.048-4.792-46.532-4.792-73.734c-0.008-18.382,1.297-36.626,4.777-51.685
          c2.887-12.717,7.415-22.822,13.05-29.253c9.053,2.066,17.436,2.817,25.268,2.81c13.815-0.03,25.881-1.884,39.167-1.853h0.314
          l0.333-0.015c4.98-0.306,9.436-0.452,13.436-0.452c12.754,0.007,20.705,1.462,27.159,3.95c6.446,2.488,11.966,6.278,19.43,12.089
          l1.922,1.492l2.392,0.421c8.754,1.569,15.239,4.686,20.472,8.919c7.798,6.323,13.049,15.656,16.361,27.232
          c3.3,11.53,4.501,25.05,4.49,38.486c0.004,11.316-0.822,22.569-1.776,32.622c-0.953,10.067-2.025,18.848-2.504,25.708h0.004
          c-0.088,1.218-0.195,2.266-0.318,3.446l-0.869,8.352l8.119,2.136c1.037,0.275,1.856,0.72,2.377,1.332
          c0.486,0.636,1.37,1.738,1.432,5.735c0,2.434-0.436,5.872-1.726,10.396l-0.008,0.024c-4.038,14.255-7.655,22.385-10.729,26.619
          c-1.543,2.136-2.867,3.384-4.345,4.425c-1.478,1.026-3.231,1.876-5.68,2.756l-5.359,1.914l-0.992,5.604
          c-1.168,6.606-2.572,11.369-4.054,15.105c-2.236,5.589-4.636,9.049-7.729,13.62c-3.062,4.509-6.752,10.121-9.635,18.168
          l-0.582,1.608v1.714c0,15.679,0,27.109,0,36.258c-0.011,5.987,2.328,11.354,5.459,15.573c4.75,6.376,11.242,10.986,18.259,15.013
          c7.032,3.989,14.684,7.258,21.876,9.952c15.212,5.658,42.64,15.902,65.836,34.444c11.592,9.256,22.06,20.487,29.613,34.137
          c7.545,13.673,12.295,29.751,12.31,49.419C459.661,491.329,459.6,491.88,459.592,492.401z"/>
      </symbol>
      <symbol id="icon-calendar" viewBox="0 0 24 24" fill="none" stroke="none">
        <path d="M3 9H21M7 3V5M17 3V5M6 13H8M6 17H8M11 13H13M11 17H13M16 13H18M16 17H18M6.2 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4802 21 18.9201 21 17.8V8.2C21 7.07989 21 6.51984 20.782 6.09202C20.5903 5.71569 20.2843 5.40973 19.908 5.21799C19.4802 5 18.9201 5 17.8 5H6.2C5.0799 5 4.51984 5 4.09202 5.21799C3.71569 5.40973 3.40973 5.71569 3.21799 6.09202C3 6.51984 3 7.07989 3 8.2V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21Z" stroke="currentcolor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </symbol>
    </sprites>
  </div>
</template>

<script setup lang="ts">
import XFooter from "~/components/layout/XFooter.vue";
import XHeader from "~/components/layout/XHeader.vue";
import ProjectSprites from "~/components/ProjectSprites.vue";
import {nextTick, onMounted, ref, watch} from "vue";
import {useRoute} from "#app";
import moment from "moment-timezone";

const $route = useRoute();

const isLoad = ref(false);
onMounted(() => isLoad.value = true);
watch(() => $route.path, () => {
  isLoad.value = false;
  nextTick(() => isLoad.value = true)
})

function syncPoints() {
  document.body.style.setProperty("--vw", `${(window.innerWidth / 100).toFixed(2)}px`);
  document.body.style.setProperty("--vh", `${(window.innerHeight / 100).toFixed(2)}px`);
}
onMounted(() => {
  syncPoints();
  window.addEventListener("resize",syncPoints);

  moment.tz.setDefault("Europe/Moscow");
})
onUnmounted(() => {
  window.removeEventListener("resize",syncPoints);
})
</script>
